module.exports = __webpack_public_path__ + "app/images/35885_Abbott_ANHI-Infographic_HMO_A4_v5[2].jpg";